import React from "react";

export interface EventService {
    status: string,
    handleStatusChange(newStatus: string): void
}

export default React.createContext<EventService>({} as EventService);